<template>
  <div>
    <header class="modal-header"></header>
    <section class="modal-body">
      <p style="white-space: pre-line;">{{ copy }}</p>
    </section>
    <footer class="modal-footer">
      <LsButton text="ok" track-id="return_request_partial_complete_reminder-ok" @click="next" />
    </footer>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { lsFilters } from 'ls-vue-common';
import { DISPUTE__GOTO_RESOLUTION_STEP } from '@/store/types';

export default {
  name: 'ReturnRequestPartialCompleteReminder',
  components: {
    LsButton,
  },
  computed: {
    ...mapState(['dispute']),
    copy() {
      const reasons = {
        gate: {
          top: 'the gate access',
          bottom: 'unlock your gates in the future',
        },
        pet: {
          top: 'a pet being outside',
          bottom: 'bring in your pets in the future',
        },
        car: {
          top: 'a car blocking the yard',
          bottom: 'move your car on the day of service in the future',
        },
        debris: {
          top: 'debris on the property',
          bottom: 'let the provider know if there will need to be a cleanup in the future',
        },
        waste: {
          top: 'pet waste',
          bottom: 'clean up pet waste ahead of your service in the future',
        },
      };

      const { contractor, schedule_event_partial_completion } = this.dispute.currentDispute;
      return `${contractor.user.first_name} was at the property on ${lsFilters.date({
        date: schedule_event_partial_completion.created_at,
      })} and reported they had an issue with ${
        reasons[schedule_event_partial_completion.reason].top
      }\n\nWe are more than happy to fix the problem but please remember to ${
        reasons[schedule_event_partial_completion.reason].bottom
      }`;
    },
  },
  methods: {
    ...mapActions([DISPUTE__GOTO_RESOLUTION_STEP]),
    next() {
      this[DISPUTE__GOTO_RESOLUTION_STEP]();
    },
  },
};
</script>

<style lang="scss" scoped></style>
